import { Actors as A, FeaturesSchema, Tenants as T } from '@mntn/auth-types'
import { IDSchema } from '@mntn/zod'
import { z } from 'zod'

const AdvertiserSchema = z.object({
  advertiserId: z.number(),
  companyName: z.string(),
  logo: z.string().nullable(),
  url: z.string(),
  lastLoginTimeForUser: z.string().nullable(),
})

const AdvertiserTenantSchema = z.object({
  kind: z.literal('advertiser'),
  current: AdvertiserSchema,
  loginAs: z.union([z.literal('admin'), z.literal('demo'), z.literal('advertiser')]),
  isBeta: z.boolean(),
  isAlpha: z.boolean(),
})

const NoneTenantSchema = z.object({
  kind: z.literal('none'),
})

const TenantSchema = z.discriminatedUnion('kind', [AdvertiserTenantSchema, NoneTenantSchema])

const UserActorSchema = z.object({
  kind: z.literal('user'),
  userId: IDSchema,
  firstName: z.string(),
  lastName: z.string(),
  emailAddress: z.string().email(),
  phoneNumber: z.string().optional(),
  orgSlug: z.string().optional(),
  isAdmin: z.boolean(),
  isMntn: z.boolean(),
  features: FeaturesSchema,
})

export const PrincipalSchema = z.object({
  tenant: TenantSchema,
  actor: UserActorSchema,
})

export const GetMeResponseSchema = z.object({
  data: PrincipalSchema.extend({
    cloudinaryAccessToken: z.string(),
    cloudinaryAccessTokenExpiresAt: z.number(),
  }),
})

export const PostSessionChangedBodySchema = z.object({
  advertiserId: z.number(),
})

export const PostSessionChangedResponseSchema = z.object({
  data: z.object({
    ok: z.literal(true),
  }),
})

export type GetMeResponse = z.infer<typeof GetMeResponseSchema>
export type Principal = z.infer<typeof PrincipalSchema>

export const GetMeRequestSchema = z.object({
  principal: T.KindSchema(['advertiser', 'none']).and(A.UserSchema),
})

export const PostSessionChangedRequestSchema = z.object({
  body: z.custom<z.output<typeof PostSessionChangedBodySchema>>(),
  principal: T.KindSchema(['advertiser', 'none']).and(A.UserSchema),
})
